export const COMPANY_KEYS = {
    base: 'companies',
    all: ['companies'],
    list: ['companies', 'list'],
    detail: (id: string) => ['companies', 'detail', id],
    products: (id: string) => ['companies', 'products', id],
    sla: (id: string) => ['companies', 'sla', id],
} as const;
